const userUpdating = (state) => state.userUpdating
const id = (state) => state.id
const externalId = (state) => state.external_id
const email = (state) => state.email
const firstName = (state) => state.firstName
const lastName = (state) => state.lastName
const birthday = (state) => state.birthday
const phoneNumber = (state) => state.phoneNumber
const phoneNumberCode = (state) => state.phoneNumberCode
const gender = (state) => state.gender
const locationName = (state) => state.locationName
const stateName = (state) => state.stateName
const languageList = (state) => state.languageList
const networkList = (state) => state.networkList
const timeSlotName = (state) => state.timeslotName
const timeslotId = (state) => state.timeslotId
const status = (state) => state.status
const timeslot = (state) => {
  return [state.timeslotName]
}
const agreementDate = (state) => state.agreementDate
const jforceTypeName = (state) => state.jforceTypeName
const recruitmentChannel = (state) => state.recruitmentChannel
const levelId = (state) => state.levelId
const ownStore = (state) => state.own_store
const salesExperience = (state) => state.sales_experience
const kraPin = (state) => state.kraPin
const isStore = (state) => state.account_type === 'store'
const storePhoto = (state) => state.store_photo
const storeName = (state) => state.store_name
const geoLocation = (state) => state.geo_location
const taxIdNumber = (state) => state.tax_id_number
const idCardNumber = (state) => state.id_card_number
const idCardPicture = (state) => state.id_card_picture
const profilePicture = (state) => state.profile_picture
const isRelativeInJumia = (state) => state.is_relative_in_jumia
const isConvicted = (state) => state.is_convicted
const address = (state) => state.address

const updatedJforceAgreement = (state) => state.updated_jforce_agreement
const updatedJforceAgreementContent = (state) =>
  state.updated_jforce_agreement_content
const updatedJforceAgreementPdf = (state) => state.updated_jforce_agreement_pdf

const user = (state) => {
  return {
    id: state.id,
    email: state.email,
    external_id: state.external_id,
    firstName: state.firstName,
    lastName: state.lastName,
    profile_picture: state.profile_picture,
    phoneNumberCode: state.phoneNumberCode,
    phoneNumber: state.phoneNumber,
    gender: state.gender,
    locationId: state.locationId,
    timeslotId: state.timeslotId,
    timeslotName: state.timeslotName,
    jforceTypeId: state.jforceTypeId,
    jforceTypeName: state.jforceTypeName,
    stateId: state.stateId,
    recruitmentChannelId: state.recruitmentChannelId,
    birthday: state.birthday,
    jforce_agreement: state.jforce_agreement,
    sales_experience: state.sales_experience,
    trained: state.trained,
    own_store: state.own_store,
    languages: state.languages,
    networks: state.networks,
    kraPin: state.kraPin,
    account_type: state.account_type,
    geo_location: state.geo_location,
    tax_id_number: state.tax_id_number,
    id_card_number: state.id_card_number,
    id_card_picture: state.id_card_picture,
    store_type: state.store_type,
    store_name: state.store_name,
    store_photo: state.store_photo,
    address: state.address,
    is_relative_in_jumia: state.is_relative_in_jumia,
    is_convicted: state.is_convicted,
    updated_jforce_agreement: state.updated_jforce_agreement,
    status: state.status,
    subject_id: state.subject_id,
    signature: state.signature
  }
}

// Errors
const phoneNumberError = (state) => state.phoneNumberError
const firstNameError = (state) => state.firstNameError
const systemError = (state) => state.systemError
const lastNameError = (state) => state.lastNameError
const emailError = (state) => state.emailError

const showAddToHome = (state) => {
  return (
    state.isJForce &&
    !state.isInactive &&
    !state.paymentMethodNeedConfirmation &&
    state.acceptedTermsAndCondition
  )
}

// Flags to access the application
const isJForce = (state) => state.isJForce
const isAuth = (state) => state.isAuth
const isInactive = (state) => state.isInactive
const isPaymentMethodMandatory = (state) => state.isPaymentMethodMandatory
const hasPaymentMethod = (state) => state.hasPaymentMethod
const acceptedAgreement = (state) => state.acceptedTermsAndCondition
const paymentMethodNeedConfirmation = (state) =>
  state.paymentMethodNeedConfirmation
const mandatoryPaymentMethod = (state) => state.mandatoryPaymentMethod

// payment Method(s)
const availablePaymentMethods = (state) => state.availablePaymentMethods
const availablePaymentMethodsLoading = (state) =>
  state.availablePaymentMethodsLoading
const availablePaymentMethodsError = (state) =>
  state.availablePaymentMethodsError

const paymentMethods = (state) => state.paymentMethods
const paymentMethodsLoading = (state) => state.paymentMethodsLoading
const paymentMethodsError = (state) => state.paymentMethodsError

const paymentMethod = (state) => state.paymentMethod
const paymentMethodLoading = (state) => state.paymentMethodLoading
const paymentMethodError = (state) => state.paymentMethodError

// Form lists
const locations = (state) => state.locations
const locationLoading = (state) => state.locationLoading
const locationError = (state) => state.locationError

// cities
const cities = (state) => state.cities
const citiesLoading = (state) => state.citiesLoading
const citiesError = (state) => state.citiesError

const banks = (state) => state.banks
const banksLoading = (state) => state.banksLoading
const banksError = (state) => state.banksError

const recruitmentChannels = (state) => state.recruitmentChannels
const recruitmentChannelsLoading = (state) => state.recruitmentChannelsLoading
const recruitmentChannelsError = (state) => state.recruitmentChannelsError

const networks = (state) => state.networks
const networksLoading = (state) => state.networksLoading
const networksError = (state) => state.networksError

const jforceTypes = (state) => state.jforceTypes
const jforceTypesLoading = (state) => state.jforceTypesLoading
const jforceTypesError = (state) => state.jforceTypesError

const languages = (state) => state.languages
const languagesLoading = (state) => state.languagesLoading
const languagesError = (state) => state.languagesError

const timeSlots = (state) => state.timeSlots
const timeSlotsLoading = (state) => state.timeSlotsLoading
const timeSlotsError = (state) => state.timeSlotsError
const isImpersonate = (state) => state.isImpersonate

export default {
  userUpdating,

  id,
  externalId,
  email,
  firstName,
  timeslotId,
  timeslot,
  lastName,
  birthday,
  phoneNumber,
  phoneNumberCode,
  gender,
  locationName,
  recruitmentChannel,
  levelId,
  stateName,
  jforceTypeName,
  timeSlotName,
  ownStore,
  salesExperience,
  kraPin,
  agreementDate,
  isConvicted,
  address,
  status,

  user,
  isStore,
  storePhoto,
  profilePicture,
  storeName,
  geoLocation,
  taxIdNumber,
  idCardNumber,
  idCardPicture,
  isRelativeInJumia,
  phoneNumberError,
  firstNameError,
  systemError,
  lastNameError,
  emailError,

  isJForce,
  isAuth,
  isInactive,
  isPaymentMethodMandatory,
  hasPaymentMethod,
  acceptedAgreement,
  paymentMethodNeedConfirmation,
  mandatoryPaymentMethod,

  availablePaymentMethods,
  availablePaymentMethodsLoading,
  availablePaymentMethodsError,

  paymentMethods,
  paymentMethodsLoading,
  paymentMethodsError,

  paymentMethod,
  paymentMethodLoading,
  paymentMethodError,

  locations,
  locationLoading,
  locationError,

  cities,
  citiesLoading,
  citiesError,

  banks,
  banksLoading,
  banksError,

  recruitmentChannels,
  recruitmentChannelsLoading,
  recruitmentChannelsError,

  networks,
  networkList,
  networksError,
  networksLoading,

  jforceTypes,
  jforceTypesError,
  jforceTypesLoading,

  languages,
  languageList,
  languagesError,
  languagesLoading,

  timeSlots,
  timeSlotsError,
  timeSlotsLoading,

  showAddToHome,
  updatedJforceAgreement,
  updatedJforceAgreementContent,
  updatedJforceAgreementPdf,
  isImpersonate
}
